import { Component } from '@angular/core';

@Component({
  selector: 'app-push-notification-link',
  templateUrl: './push-notification-link.component.html',
  styleUrls: ['./push-notification-link.component.scss']
})
export class PushNotificationLinkComponent {

}
